import {
  findTimeZone,
  getUTCOffset,
  getZonedTime,
  listTimeZones,
} from 'timezone-support/dist/index-1970-2038';

// the timezone value assigned if the organization has not set the timezone
export const LOCAL_TZ_VALUE = 'local';

function getOffsetText(offsetInSeconds: number) {
  const isUtc = offsetInSeconds === 0;
  const isGreaterThanUtc = offsetInSeconds < 0;
  const offset = Math.abs(offsetInSeconds / 60);
  const offsetHours = Math.floor(offset);
  const offsetMinutes = 60 * (offset % 1);

  if (isUtc) return 'GMT';

  const hoursLabel = `${offsetHours < 10 ? `0${offsetHours}` : offsetHours}`;
  const minutesLabel = offsetMinutes > 1 ? offsetMinutes : '00';

  return `GMT${isGreaterThanUtc ? '+' : '-'}${hoursLabel}:${minutesLabel}`;
}

function getPrettyTimezoneName(tz: string) {
  switch (tz) {
    case 'Etc/GMT+12':
      return 'International Date Line West';
    default: {
      const [cityPart] = tz.split('/').reverse();
      let cityPartClean = cityPart.replace('_', ' ');
      if (cityPartClean.startsWith('GMT-')) cityPartClean = cityPartClean.replace('GMT-', 'GMT+');
      else if (cityPartClean.startsWith('GMT+'))
        cityPartClean = cityPartClean.replace('GMT+', 'GMT-');
      return cityPartClean;
    }
  }
}

export const TZ_ITEMS: {
  value: string;
  label: string;
  offset: number;
}[] = [
  ...listTimeZones()
    .map((tz) => {
      const now = new Date();

      const zone = findTimeZone(tz);
      const { offset } = getUTCOffset(now, zone);

      return {
        value: tz,
        label: `${getPrettyTimezoneName(tz)} (${getOffsetText(offset)})`,
        offset,
      };
    })
    .sort((a, b) => b.offset - a.offset),
];

const TZ_POSITION_MAP = TZ_ITEMS.reduce<Record<string, number>>((acc, tz, currentIndex) => {
  acc[tz.value] = currentIndex;
  return acc;
}, {});

export function getTimezoneValue(tz: string) {
  return TZ_ITEMS[TZ_POSITION_MAP[tz]];
}

export function getZonedDate(d: Date, tz?: string) {
  if (!tz) return d;
  const zone = findTimeZone(tz);
  const zt = getZonedTime(d.getTime(), zone);
  const zonedDate = new Date(
    zt.year,
    zt.month - 1,
    zt.day,
    zt.hours,
    zt.minutes,
    zt.seconds,
    zt.milliseconds,
  );
  return zonedDate;
}
